import useAlbumStore from "../store/albumStore";
import useSongWriterAssignmentStore from "../store/songWriterAssignmentStore";
import useWriterStore from "../store/writerStore";

export type ValidationResult = {
  isValid: boolean;
  errorMessage: string;
  songsWithoutWriters: Array<{ id: string; name: string }>;
};

export function validateAllSongsHaveWriters(): ValidationResult {
  const albumStore = useAlbumStore.getState();
  const writerStore = useWriterStore.getState();
  const assignmentStore = useSongWriterAssignmentStore.getState();

  const selectedTracks = albumStore.tracks.filter(track => track.isSelected);
  const selectedWriters = writerStore.selectedWriters;
  const assignments = assignmentStore.assignments;

  if (selectedTracks.length === 0 || selectedWriters.length === 0) {
    return {
      isValid: false,
      errorMessage: "No songs or writers selected.",
      songsWithoutWriters: [],
    };
  }

  const songsWithoutWriters = selectedTracks.filter((track) => {
    const songAssignments = assignments[track.id];
    if (typeof songAssignments === "undefined") {
      return true; // No assignments for this song
    }
    return selectedWriters.every(writer => !songAssignments[writer.writercode]);
  });

  const songsWithoutWritersCount = songsWithoutWriters.length;

  return {
    isValid: songsWithoutWritersCount === 0,
    errorMessage: songsWithoutWritersCount > 0
      ? `${songsWithoutWritersCount} song${songsWithoutWritersCount === 1 ? "" : "s"} still need${songsWithoutWritersCount === 1 ? "s" : ""} at least one writer assigned: ${songsWithoutWriters.slice(0, 3).map(s => s.name).join(", ")}${songsWithoutWritersCount > 3 ? ` and ${songsWithoutWritersCount - 3} more` : ""}`
      : "",
    songsWithoutWriters: songsWithoutWriters.map(s => ({ id: s.id, name: s.name })),
  };
}
